// You can write more code here

import { ButtonController } from '@/game/prefabs/GeneralUI/Buttons/ButtonController';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class DialogueOptionButton_m
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // buttonBacking
    const buttonBacking = scene.add.nineslice(
      0,
      0,
      'dialogue-option-button',
      undefined,
      288,
      20,
      10,
      10,
      10,
      10,
    );
    buttonBacking.scaleX = 2;
    buttonBacking.scaleY = 2;
    this.add(buttonBacking);

    // buttonLabel
    const buttonLabel = scene.add.bitmapText(0, 0, 'Aronui', 'New BitmapText');
    buttonLabel.setOrigin(0.5, 0.5);
    buttonLabel.text = 'New BitmapText';
    buttonLabel.fontSize = -20;
    this.add(buttonLabel);

    // attentionIcon
    const attentionIcon = scene.add.image(-264, 0, 'hud-icons', 240);
    attentionIcon.scaleX = 2;
    attentionIcon.scaleY = 2;
    this.add(attentionIcon);

    this.buttonBacking = buttonBacking;
    this.buttonLabel = buttonLabel;
    this.attentionIcon = attentionIcon;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    this._controller = new ButtonController({
      buttonBacking,
      buttonLabel,
      defaultTexture: 'dialogue-option-button',
      hoverTexture: 'dialogue-option-button-hover',
      submitTexture: 'dialogue-option-button',
      disabledTexture: 'dialogue-option-button-disabled',
    });
    /* END-USER-CTR-CODE */
  }

  private buttonBacking: Phaser.GameObjects.NineSlice;
  private buttonLabel: Phaser.GameObjects.BitmapText;
  private attentionIcon: Phaser.GameObjects.Image;
  public buttonText: string = '';

  /* START-USER-CODE */

  _controller: ButtonController;
  get controller() {
    return this._controller;
  }

  awake() {
    const { buttonBacking, buttonLabel } = this;

    buttonLabel.setText(this.buttonText);

    return { button: buttonBacking, text: buttonLabel };
  }

  setAttentionIconVisible(visible: boolean) {
    this.attentionIcon.setVisible(visible);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
